"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { insertImagesFromPicker } from "../../editor/image-upload";
import { LuImage } from "react-icons/lu";
import { Button } from "@/components/ui";

/** Same path as `/image`: picker, skeleton, a row of its own. */
export function ImageInsertButton() {
  const $ = _c(5);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = () => editor && void insertImagesFromPicker(editor, "toolbar");
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuImage size={16} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" onClick={t0} tooltip="Insert image" aria-label="Insert image">{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}